import React from 'react'

function TemplateSelectionStep({ templateOption, setTemplateOption, templates, setTemplates, selectedTemplate, setSelectedTemplate, loadingTemplates, setLoadingTemplates }) {
    return (
        <div className="animate-fade-in">
            <h3 className="fw-bold text-gray-900 mb-2">Select Template</h3>
            <p className="text-muted mb-8">Choose to start from scratch or use an existing template.</p>
            
            <div className="row g-4 mb-6">
                <div className="col-md-6">
                    <div 
                        className={`card h-100 cursor-pointer border-2 ${templateOption === 'blank' ? 'border-primary bg-light-primary' : 'border-gray-200'}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setTemplateOption('blank')}
                    >
                        <div className="card-body p-6 text-center">
                            <div className="mb-4">
                                <span className="svg-icon svg-icon-6x svg-icon-primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"></path>
                                        <path d="M12 8V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"></path>
                                        <path d="M8 12H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"></path>
                                    </svg>
                                </span>
                            </div>
                            <h5 className="fw-bold mb-2">Start Blank</h5>
                            <p className="text-muted mb-0">Create a new campaign from scratch</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div 
                        className={`card h-100 cursor-pointer border-2 ${templateOption === 'template' ? 'border-primary bg-light-primary' : 'border-gray-200'}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setTemplateOption('template')}
                    >
                        <div className="card-body p-6 text-center">
                            <div className="mb-4">
                                <span className="svg-icon svg-icon-6x svg-icon-primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                    </svg>
                                </span>
                            </div>
                            <h5 className="fw-bold mb-2">Use Template</h5>
                            <p className="text-muted mb-0">Select from existing templates</p>
                        </div>
                    </div>
                </div>
            </div>

            {templateOption === 'template' && (
                <div className="card border-0 bg-light">
                    <div className="card-body">
                        <h5 className="fw-bold mb-4">Available Templates</h5>
                        {loadingTemplates ? (
                            <div className="text-center py-8">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : templates.length === 0 ? (
                            <div className="text-center py-8 text-muted">
                                <p>No templates available</p>
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Template Name</th>
                                            <th>Created Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {templates.map((template, index) => (
                                            <tr key={index}>
                                                <td>{template.name}</td>
                                                <td>{template.createdDate}</td>
                                                <td>
                                                    <button 
                                                        className={`btn btn-sm ${selectedTemplate === template ? 'btn-primary' : 'btn-light-primary'}`}
                                                        onClick={() => setSelectedTemplate(template)}
                                                    >
                                                        {selectedTemplate === template ? 'Selected' : 'Select'}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default TemplateSelectionStep
